var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyteDiscoveryListingMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.973022,
    width: 17.027,
    height: 17.027,
    rx: 5,
    fill: "white",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2162 3.99759C15.2162 3.32731 14.6728 2.78395 14.0025 2.78395L11.7445 2.78395L11.7445 1.82433L14.0025 1.82433C15.2028 1.82433 16.1758 2.79733 16.1758 3.99759L16.1758 6.25552L15.2162 6.25552L15.2162 3.99759Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75699 3.99759C3.75699 3.32731 4.30036 2.78395 4.97064 2.78395L7.2286 2.78395L7.2286 1.82433L4.97064 1.82433C3.77037 1.82433 2.79736 2.79733 2.79736 3.99759L2.79736 6.25552L3.75699 6.25552L3.75699 3.99759Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0025 14.2431C14.6728 14.2431 15.2162 13.6997 15.2162 13.0294L15.2162 10.7715L16.1758 10.7715L16.1758 13.0294C16.1758 14.2297 15.2028 15.2027 14.0025 15.2027L11.7445 15.2027L11.7445 14.2431L14.0025 14.2431Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75699 13.0294C3.75699 13.6997 4.30036 14.2431 4.97064 14.2431L7.2286 14.2431L7.2286 15.2027L4.97064 15.2027C3.77037 15.2027 2.79736 14.2297 2.79736 13.0294L2.79736 10.7715L3.75699 10.7715L3.75699 13.0294Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8696 7.94904C10.8696 8.97783 10.0356 9.81183 9.00677 9.81183C7.97796 9.81183 7.14396 8.97783 7.14396 7.94904C7.14396 6.92024 7.97796 6.08624 9.00677 6.08624C10.0356 6.08624 10.8696 6.92024 10.8696 7.94904ZM10.6344 10.2552C10.1744 10.5804 9.61292 10.7715 9.00677 10.7715C7.44798 10.7715 6.18433 9.50782 6.18433 7.94904C6.18433 6.39026 7.44798 5.12662 9.00677 5.12662C10.5656 5.12662 11.8292 6.39026 11.8292 7.94904C11.8292 8.55517 11.6381 9.11667 11.3129 9.57661L13.2975 11.5611L12.6189 12.2397L10.6344 10.2552Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteDiscoveryListingMobile);
export default __webpack_public_path__ + "static/media/syte-discovery-listing-mobile.ce5bd9d7.svg";
export { ForwardRef as ReactComponent };